import { render, staticRenderFns } from "./wizard-body.vue?vue&type=template&id=70c27f71&scoped=true"
import script from "./wizard-body.vue?vue&type=script&lang=js"
export * from "./wizard-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c27f71",
  null
  
)

export default component.exports